import { render } from "./VehicleManage.vue?vue&type=template&id=03756d56&scoped=true"
import script from "./VehicleManage.vue?vue&type=script&lang=js"
export * from "./VehicleManage.vue?vue&type=script&lang=js"

import "./VehicleManage.vue?vue&type=style&index=0&id=03756d56&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03756d56"]])

export default __exports__